import React from "react"
import PropTypes from 'prop-types';
import { CardSection } from "../CardSection/CardSection"

export const Colaboradores = (props) => {
    return (
        <CardSection 
            title="Colaboradores"
            items={props.collaborators}
        />
    );
}

Colaboradores.propTypes = {
    collaborators: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        url_image: PropTypes.string.isRequired,
        type: PropTypes.string,
    })),
};